export const foregroundConfig = {
    fpsLimit: 30,
    interactivity: {
        events: {
            onHover: {
                enable: true,
                mode: "grab",
            },
            resize: true,
        },
        modes: {
            push: {
                quantity: 4,
            },
            grab: {
                distance: 200,
                line_linked: {
                    opacity: 1,
                },
            },
            repulse: {
                distance: 64,
                duration: 0.4,
            },
        },
    },
    particles: {
        color: {
            value: ["#c0dcf8"],
            animation: {
                s: {
                    enable: true,
                    speed: 20,
                    sync: false,
                    offset: {
                        max: 40,
                        min: 0,
                    },
                },
            },
        },
        links: {
            color: "#5c7cba",
            distance: 150,
            enable: true,
            opacity: 1,
            width: 1,
        },
        move: {
            direction: "none",
            enable: true,
            outModes: {
                default: "bounce",
            },
            random: false,
            speed: 0.25,
            straight: false,
        },
        number: {
            density: {
                enable: true,
                area: 1500,
            },
            value: 200,
        },
        opacity: {
            value: 0.75,
        },
        shape: {
            type: "circle",
        },
        size: {
            value: { min: 1, max: 3 },
        },
    },
    polygon: {
        draw: {
            enable: false,
            stroke: {
                color: "#fff",
                opacity: 0.2,
                width: 1,
            },
        },
        enable: false,
        move: {
            radius: 0,
        },
        position: {
            x: 50,
            y: 50,
        },
        scale: 20,
        type: "inside",
        url: "/images/hero-mask.svg",
    },
    detectRetina: true,
};

export const backgroundConfig = {
    fpsLimit: 30,
    interactivity: {
        events: {
            onHover: {
                enable: false,
                mode: "repulse",
            },
            resize: true,
        },
        modes: {
            push: {
                quantity: 4,
            },
            grab: {
                distance: 150,
                line_linked: {
                    opacity: 1,
                },
            },
            repulse: {
                distance: 64,
                duration: 0.4,
            },
        },
    },
    particles: {
        color: {
            value: "#9ebaea",
        },
        links: {
            color: "#5c7cba",
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 2,
        },
        move: {
            direction: "none",
            enable: true,
            outModes: {
                default: "bounce",
            },
            random: true,
            speed: 0.5,
            straight: false,
        },
        number: {
            density: {
                enable: true,
                area: 1500,
            },
            value: 400,
        },
        opacity: {
            value: 0.5,
        },
        shape: {
            type: "circle",
        },
        size: {
            value: { min: 1, max: 5 },
        },
    },
    polygon: {
        draw: {
            enable: false,
            stroke: {
                color: "#fff",
                opacity: 0.2,
                width: 1,
            },
        },
        enable: false,
        move: {
            radius: 0,
        },
        position: {
            x: 50,
            y: 50,
        },
        scale: 20,
        type: "inside",
        url: "/images/hero-mask.svg",
    },
    detectRetina: true,
};

export const aiConfig = {
    pauseOnBlur: false,
    interactivity: {
        events: {
            onHover: {
                enable: true,
                mode: ["bubble", "grab"],
            },
        },
        modes: {
            bubble: {
                distance: 40,
                duration: 2,
                opacity: 8,
                size: 6,
                speed: 3,
            },
            grab: {
                distance: 60,
            },
        },
    },
    particles: {
        color: {
            value: ["#5ba2f9", "#7ee1ec"],
        },
        animation: {
            h: { enable: false },
            s: { enable: false },
            l: {
                enable: true,
                speed: 2,
                sync: false,
                offset: {
                    max: 40,
                    min: 0,
                },
            },
        },

        links: {
            color: "#5ba2f9",
            distance: 50,
            enable: true,
            opacity: 0.5,
            width: 1,
        },
        move: {
            direction: "none",
            enable: true,
            outModes: "bounce",
            speed: 0.2,
        },
        number: {
            density: {
                enable: false,
                area: 200,
            },
            value: 300,
        },
        opacity: {
            animation: {
                enable: true,
                speed: 1,
                sync: false,
            },
            value: { min: 0.5, max: 0.8 },
        },
        shape: {
            type: "circle",
        },
        size: {
            value: {
                max: 3,
                min: 1,
            },
            animation: {
                enable: true,
                speed: 2,
                sync: false,
                startValue: "random",
            },
        },
    },
    polygon: {
        draw: {
            enable: false,
            stroke: {
                color: "#fff",
                opacity: 0.2,
                width: 1,
            },
        },
        enable: true,
        move: {
            radius: 0,
        },
        position: {
            x: 50,
            y: 50,
        },
        scale: 1,
        type: "inside",
        url: "/images/ai-biomarker.svg",
    },
    background: {
        color: "transparent",
    },
};

export const linesConfig = {
    pauseOnBlur: false,
    interactivity: {
        events: {
            onHover: {
                enable: true,
                mode: ["bubble", "grab"],
            },
            onClick: {
                enable: true,
                mode: "push",
            },
            resize: true,
        },
        modes: {
            bubble: {
                distance: 40,
                duration: 2,
                opacity: 8,
                size: 6,
                speed: 3,
            },
            grab: {
                distance: 60,
            },
        },
    },
    particles: {
        color: {
            value: "#ff6c2d",
        },
        animation: {
            h: { enable: false },
            s: { enable: false },
            l: {
                enable: true,
                speed: 2,
                sync: false,
                offset: {
                    max: 40,
                    min: 0,
                },
            },
        },

        links: {
            color: "#5ba2f9",
            distance: 50,
            enable: false,
            opacity: 0.5,
            width: 1,
        },
        move: {
            direction: "none",
            enable: true,
            outModes: "bounce",
            random: false,
            straight: true,
            speed: 1,
        },
        number: {
            density: {
                enable: false,
                area: 200,
            },
            value: 10,
            limit: 10,
        },
        opacity: {
            animation: {
                enable: false,
                speed: 1,
                sync: false,
            },
            value: { min: 0.5, max: 0.8 },
        },
        shape: {
            type: "circle",
        },
        size: {
            value: {
                max: 3,
                min: 1,
            },
            animation: {
                enable: true,
                speed: 2,
                sync: false,
                startValue: "random",
            },
        },
    },
    polygon: {
        draw: {
            enable: false,
            stroke: {
                color: "#fff",
                opacity: 0.2,
                width: 1,
            },
        },
        enable: false,
        move: {
            radius: 10,
        },
        position: {
            x: 50,
            y: 50,
        },
        inline: {
            arrangement: "equidistant",
        },
        scale: 1,
        type: "inline",
        url: "/images/biomarkers-lines-large-tracer.svg",
    },
    background: {
        color: "transparent",
    },
};

export const physicalConfig = {
    pauseOnBlur: false,
    interactivity: {
        events: {
            onHover: {
                enable: true,
                mode: ["bubble", "grab"],
            },
        },
        modes: {
            bubble: {
                distance: 40,
                duration: 2,
                opacity: 8,
                size: 6,
                speed: 3,
            },
            grab: {
                distance: 60,
            },
        },
    },
    particles: {
        color: {
            value: ["#5ba2f9", "#7ee1ec"],
        },
        animation: {
            h: { enable: false },
            s: { enable: false },
            l: {
                enable: true,
                speed: 2,
                sync: false,
                offset: {
                    max: 40,
                    min: 0,
                },
            },
        },

        links: {
            color: "#5ba2f9",
            distance: 70,
            enable: true,
            opacity: 0.5,
            width: 1,
        },
        move: {
            direction: "none",
            enable: true,
            outModes: "bounce",
            speed: 0.2,
        },
        number: {
            density: {
                enable: false,
                area: 200,
            },
            value: 200,
        },
        opacity: {
            animation: {
                enable: true,
                speed: 1,
                sync: false,
            },
            value: { min: 0.5, max: 0.8 },
        },
        shape: {
            type: "circle",
        },
        size: {
            value: {
                max: 4,
                min: 1,
            },
            animation: {
                enable: true,
                speed: 2,
                sync: false,
                startValue: "random",
            },
        },
    },
    polygon: {
        draw: {
            enable: false,
            stroke: {
                color: "#fff",
                opacity: 0.2,
                width: 1,
            },
        },
        enable: true,
        move: {
            radius: 0,
        },
        position: {
            x: 50,
            y: 50,
        },
        scale: 1,
        type: "inside",
        url: "/images/physical-biomarker.svg",
    },
    background: {
        color: "transparent",
    },
};
